import { createStyles } from '@mantine/core';

import type { BalanceUpdateLayout, BalanceUpdateVariant } from './types';

interface StyleParams {
  variant: BalanceUpdateVariant;
  layout: BalanceUpdateLayout;
  showBorder: boolean;
  showBottomDivider: boolean;
}

const useStyles = createStyles(
  (theme, { variant, layout, showBorder, showBottomDivider }: StyleParams) => {
    const isDark = variant === 'dark';
    const isCompact = layout === 'compact';

    const getTitleColor = () => {
      if (isCompact) return theme.colors.gray2[3];
      return isDark ? theme.white : theme.colors.gray2[6];
    };

    const getContainerStyles = () => {
      if (isCompact) {
        return { width: '100%' };
      }

      if (!showBorder) {
        return {
          width: '100%',
          padding: `${theme.other.spacing._12}px 0`,
          ...(showBottomDivider && {
            borderBottom: `1px solid ${isDark ? theme.colors.gray2[5] : theme.colors.gray2[1]}`,
          }),
        };
      }

      return {
        backgroundColor: isDark ? theme.colors.gray2[6] : theme.white,
        borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 12,
        border: `1px solid ${isDark ? theme.colors.gray2[5] : theme.colors.gray2[1]}`,
        padding: `${theme.other.spacing._12}px ${theme.other.spacing._16}px`,
        width: '100%',
      };
    };

    return {
      container: {
        display: 'flex',
        flexDirection: isCompact ? 'row' : 'column',
        alignItems: isCompact ? 'center' : 'flex-start',
        justifyContent: isCompact ? 'center' : 'flex-start',
        gap: isCompact ? theme.other.spacing._4 : 0,
        ...getContainerStyles(),
      },

      title: {
        color: getTitleColor(),
      },

      balanceRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.other.spacing._4,
      },

      label: {
        color: theme.colors.gray2[2],
      },

      previousBalance: {
        color: theme.colors.gray2[3],
        textDecoration: 'line-through',
      },

      arrow: {
        color: theme.colors.gray2[2],
      },

      newBalance: {
        color: theme.colors.gray2[4],
      },
    };
  }
);

export default useStyles;
